module.exports = __webpack_public_path__ + "ida_design_awards_fashion_graphic_product_design_typography_colors_moodboard.jpg?88556584a9d6366dd9dfe1c8b0b674d4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_design_awards_fashion_graphic_product_design_typography_colors_moodboard.jpg
// module id = 63
// module chunks = 0